<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-delete"
    style="user-select: auto !important;"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>
        SQL Detail
        <v-spacer />
        <v-icon small class="mr-2" @click="removeDialog" color="white">fas fa-times</v-icon>
      </v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <!-- [S]  Popup body-->
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :headers="headers"
                  :items="dataPoolList"
                  :hide-default-footer="true"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  :height="customHeight"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.QR_ID">
                        <td class="code-grp-col no-wrap">{{ item.QR_NM }}</td>
                        <td class="code-grp-col no-wrap">{{ item.QR_DB }}</td>
                        <td class="code-grp-col">
                          <p>{{ item.QR_TXT }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{ $t('btn.common.reset') }}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
      <!-- [S]  Popup buttons-->
      <v-card-text class="footer-display-popup">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <v-btn class="btn btn-delete float-right" tile dark @click="removeDialog">
              {{ $t('btn.common.close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup buttons-->
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';

export default {
  components: {
    DialogDrag,
  },
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  data: () => ({
    versionList: [],
    customHeight: 300,
    queryPoolItems: {},
    dataPoolList: [],
    typeDBList: {},
    isLoading: false,
    page: 1,
    pageCount: 1,
    itemsPerPage: 100,
    pageEnter: 1,
    headers: [
      { text: 'Query Name', value: 'QR_NM' },
      { text: 'DB Name', value: 'QR_DB' },
      { text: 'Query Text', value: 'QR_TXT' },
    ],
  }),
  watch: {},
  created() {
    this.getQueryPoolList(this.options.item.dbBrokerId);
  },
  computed: {},
  methods: {
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    getQueryPoolList(id) {
      this.isLoading = true;
      this.queryPoolItems.CUST_ID = this.$cookies.get('comp-id');
      this.queryPoolItems.OWNR_CUST_ID = this.$cookies.get('ownr-id');
      this.queryPoolItems.DBBRK_ID = id;

      this.queryPoolItems.R_FROM = this.itemsPerPage * (this.page - 1) + 1;
      this.queryPoolItems.R_TO = this.itemsPerPage * this.page;

      this.$store
        .dispatch('getQueryPoolList', this.queryPoolItems)
        .then((res) => {
          this.dataPoolList = res.queryPoolList;
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
